import { useEffect, useState } from "react";
import { api, ApiError, type Me } from "./api";

export interface AuthState {
  user: Me | null;
  loading: boolean;
  isAuthenticated: boolean;
  logout: () => Promise<void>;
}

export function useAuth(): AuthState {
  const [user, setUser] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .me()
      .then((u) => {
        if (!cancelled) setUser(u);
      })
      .catch((err) => {
        if (!cancelled && !(err instanceof ApiError && err.status === 401)) {
          // 401 is expected when signed-out; any other error gets surfaced.
          console.error("auth/me failed", err);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return {
    user,
    loading,
    isAuthenticated: !!user,
    logout: async () => {
      try {
        await api.logout();
      } finally {
        setUser(null);
        window.location.href = "/";
      }
    },
  };
}
